
import React from "react";
import ReactDOM from "react-dom/client";
import Comp from "/src/pages/admin-login.tsx";
const serverSideProps = window.serverSideProps;
ReactDOM.hydrateRoot(
  document.getElementById("root"),
  <Comp serverSideProps={serverSideProps} />
)
